// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as React from "react";

import { useMemo } from "@mairistem/tools";

import { DomainService } from "../services";

import { DataProvider } from "../../libs/components/DataProvider";

export const DomainDataProvider = (props) => {
	const { children } = props;

	const [domains, loading, fetching] = DomainService.queryDomains();

	return useMemo(
		() => (
			<DataProvider data={domains} loading={loading} fetching={fetching}>
				{children}
			</DataProvider>
		),
		[children, loading, fetching, domains],
	);
};
